import React, { useCallback, ReactNode, CSSProperties } from "react";
import cls from "classnames";
import { NavBar, FixedTop } from "@al/akui-mobile";

import goBack from "~/common/utils/goBack";
import Iconfont from "~/components/ui/Iconfont";

import styles from "./styles.scss";

export interface NavBarProps {
  back?: string | null;
  backArrow?: boolean | ReactNode;
  left?: ReactNode;
  right?: ReactNode;
  onBack?: () => void;
  className?: string;
  style?: CSSProperties;
  tabIndex?: number;
  children?: React.ReactNode;
}

const TopBar = ({ children, className, onBack, ...rest }: NavBarProps): JSX.Element => {
  const handleBack = useCallback(() => {
    if (onBack) {
      onBack?.();
    } else {
      goBack();
    }
  }, [onBack]);
  return (
    <FixedTop height={"0.56rem"} top={"0px"} alwaysFixed>
      <NavBar
        backArrow={<Iconfont className={styles.back_icon} name="back" />}
        className={cls(styles.nav_bar, className)}
        onBack={handleBack}
        {...rest}
      >
        {children}
      </NavBar>
    </FixedTop>
  );
};

export default TopBar;
